import { SavedInvestorFilter } from '@/store/settingsApi';

/**
 * Generates a UUID v4 string
 */
export function generateUUID(): string {
  return crypto.randomUUID();
}

/**
 * Ensures all saved filters have UUIDs, adding them if missing
 */
export function ensureSavedFiltersHaveIds(
  filters: SavedInvestorFilter[],
): SavedInvestorFilter[] {
  return filters.map((filter) => ({
    ...filter,
    id: filter.id || generateUUID(),
  }));
}

/**
 * Finds a saved filter by its ID
 */
export function findSavedFilterById(
  filters: SavedInvestorFilter[],
  id: string,
): SavedInvestorFilter | undefined {
  return filters.find((filter) => filter.id === id);
}

/**
 * Finds a saved filter by its text (fallback for legacy compatibility)
 */
export function findSavedFilterByText(
  filters: SavedInvestorFilter[],
  text: string,
): SavedInvestorFilter | undefined {
  return filters.find((filter) => filter.text === text);
}
